<template>
  <aside
    class="tw-z-30 tw-m-0 tw-flex tw-flex-col tw-bg-aside-600 tw-p-0 tw-align-top tw-text-white tw-transition-all dark:tw-text-dorian-gray-500 max-lg:tw-absolute max-lg:tw-bottom-0 max-lg:tw-left-0 max-lg:tw-top-0"
    :class="[
      internalState
        ? 'tw-w-14'
        : isNarrow
          ? 'tw-w-[197px]'
          : 'tw-min-w-[300px]',
    ]"
  >
    <div class="tw-mb-3 tw-flex tw-items-center tw-p-4">
      <div>
        <button data-test-id="toggle-btn" @click="toggleNav">
          <ClIconList width="24px" height="24px" />
        </button>
      </div>

      <div
        v-if="slots['company-logo']"
        class="tw-ml-3 tw-flex tw-w-full tw-justify-center"
        data-test-id="company-logo"
      >
        <a href="/">
          <slot name="company-logo" :is-closed="internalState"></slot>
        </a>
      </div>

      <div
        v-if="slots['products-section']"
        class="tw-ml-3 tw-p-4"
        data-test-id="products-section"
      >
        <slot name="products-section" :is-closed="internalState"></slot>
      </div>

      <div
        v-if="slots['users-section']"
        class="tw-ml-3 tw-p-4"
        data-test-id="users-section"
      >
        <slot name="users-section" :is-closed="internalState"></slot>
      </div>
    </div>

    <div v-if="slots['dropdown-select']" data-test-id="dropdown-select">
      <slot
        name="dropdown-select"
        :is-closed="internalState"
        :isNarrow="isNarrow"
      ></slot>
    </div>

    <div
      v-if="slots['side-nav']"
      data-test-id="side-nav"
      class="tw-relative tw-my-3 tw-h-full"
      :class="!internalState && 'tw-overflow-y-auto'"
    >
      <slot name="side-nav" :is-closed="internalState"></slot>
    </div>

    <div class="tw-mt-auto tw-p-4">
      <div
        v-if="slots['info-section']"
        class="tw-mb-3"
        data-test-id="info-section"
      >
        <slot name="info-section" :is-closed="internalState"></slot>
      </div>
    </div>
  </aside>
</template>

<script lang="ts" setup>
import { useSlots, ref, watch, computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import { ClIconList } from "@cl/components";

const { width } = useWindowSize();
const slots = useSlots();
const emit = defineEmits(["update:modelValue"]);

const { isNarrow = false, modelValue = undefined } = defineProps<{
  isNarrow?: boolean;
  modelValue?: boolean;
}>();
const localState = ref<boolean>(false);

const internalState = computed({
  get() {
    return modelValue ?? localState.value;
  },
  set(val: boolean) {
    if (modelValue !== undefined) {
      emit("update:modelValue", val);
    } else {
      localState.value = val;
    }
  },
});

if (modelValue === undefined) {
  watch(
    width,
    (newWidth) => {
      if (newWidth > 1024 && internalState.value) {
        internalState.value = false;
      }

      if (newWidth < 1024 && !internalState.value) {
        internalState.value = true;
      }
    },
    { immediate: true },
  );
}

function toggleNav() {
  internalState.value = !internalState.value;
}
</script>
